// Angular
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// Models
import { AppCleanup, DateRange } from '../models';

@Injectable({
	providedIn: 'root',
})
export class DateRangeService extends AppCleanup implements OnInit, OnDestroy {
	ngOnInit() {}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
	public currentDateRange: DateRange;
	private dateRange = new Subject<DateRange>();

	changeDateRange(dateRange: DateRange) {
		this.currentDateRange = dateRange;
		this.dateRange.next(dateRange);
	}

	clearDateRange() {
		this.dateRange.next(null);
	}

	onDateRangeChanged(): Observable<DateRange> {
		return this.dateRange.asObservable();
	}
}
